import { render } from "./AccountSettings.vue?vue&type=template&id=4f6b8804&ts=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__